interface TabPanelProps {
  children?: React.ReactNode
  index: any
  value: any
}

export function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props

  return (
    <div
      key={index}
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      style={{
        paddingTop: '8px',
        width: '100%',
      }}
      {...other}
    >
      {value === index && <div style={{ width: '100%' }}>{children}</div>}
    </div>
  )
}
